module.exports = __webpack_public_path__ + "static/media/2_1yang.e9f2b0c6.png";